import React from 'react';
import type { Answers } from '../../types/application';
import { AddressStep, GoalStep, PriceStep, StageStep, TypeStep, UseStep } from './steps/PropertySteps';
import { ContactStep, HomeAddressStep, HousingStep, NameStep, StatusStep } from './steps/AboutSteps';
import { EmployerStep, EmploymentStep, OtherIncomeStep, PayStep } from './steps/IncomeSteps';
import { AccountsStep, DebtsStep, RealEstateStep } from './steps/AssetSteps';
import { DeclarationGroupStep, DemographicsStep } from './steps/DeclarationSteps';
import { ReviewStep } from './steps/ReviewStep';
interface StepEntry {
  render: () => React.ReactNode;
  canContinue?: (a: Answers) => boolean;
}
export const stepRegistry: Record<string, StepEntry> = {
  goal: {
    render: () => <GoalStep data-id="element-63" data-mp="3b65l26an7kwp" />,
    canContinue: a => !!a.goal
  },
  stage: {
    render: () => <StageStep data-id="element-64" data-mp="1lrh8o521y2yo" />,
    canContinue: a => !!a.propertyStage
  },
  type: {
    render: () => <TypeStep data-id="element-65" data-mp="1grwa3vqsnwmh" />,
    canContinue: a => !!a.propertyType
  },
  use: {
    render: () => <UseStep data-id="element-66" data-mp="2pjbusjcm18j2" />,
    canContinue: a => !!a.occupancy
  },
  price: {
    render: () => <PriceStep data-id="element-67" data-mp="2pl6fbwjyyymm" />,
    canContinue: a => a.price > 0
  },
  address: {
    render: () => <AddressStep data-id="element-68" data-mp="2tlqef5o3scbe" />
  },
  name: {
    render: () => <NameStep data-id="element-69" data-mp="2tikl1e8fyo9v" />,
    canContinue: a => !!a.firstName && !!a.lastName
  },
  contact: {
    render: () => <ContactStep data-id="element-70" data-mp="2yi6zts3x4cks" />
  },
  status: {
    render: () => <StatusStep data-id="element-71" data-mp="33b02mafttau8" />,
    canContinue: a => !!a.maritalStatus && !!a.citizenship
  },
  home: {
    render: () => <HomeAddressStep data-id="element-72" data-mp="38amheobayz55" />
  },
  housing: {
    render: () => <HousingStep data-id="element-73" data-mp="38bxksn0u64vq" />,
    canContinue: a => !!a.housing
  },
  employment: {
    render: () => <EmploymentStep data-id="element-74" data-mp="3d7d07jehs8u9" />,
    canContinue: a => !!a.employmentType
  },
  employer: {
    render: () => <EmployerStep data-id="element-75" data-mp="3hbsz30poufzz" />
  },
  pay: {
    render: () => <PayStep data-id="element-76" data-mp="3m9m6fx2q9g1u" />
  },
  'other-income': {
    render: () => <OtherIncomeStep data-id="element-77" data-mp="3m8b3fzh3wcbs" />
  },
  accounts: {
    render: () => <AccountsStep data-id="element-78" data-mp="1mwi2xsv40oub" />
  },
  'real-estate': {
    render: () => <RealEstateStep data-id="element-79" data-mp="1mxs2ynliw73l" />,
    canContinue: a => !!a.ownsOtherProperty
  },
  debts: {
    render: () => <DebtsStep data-id="element-80" data-mp="1rwmjfiw0pjkj" />
  },
  'decl-property': {
    render: () => <DeclarationGroupStep stepId="decl-property" data-id="element-81" data-mp="1rxefeutj1jbc" />
  },
  'decl-transaction': {
    render: () => <DeclarationGroupStep stepId="decl-transaction" data-id="element-82" data-mp="2v8lafztskw4c" />
  },
  'decl-history': {
    render: () => <DeclarationGroupStep stepId="decl-history" data-id="element-83" data-mp="2q98nzg6u1r2a" />
  },
  demographics: {
    render: () => <DemographicsStep data-id="element-84" data-mp="347yjire07ioj" />
  },
  review: {
    render: () => <ReviewStep data-id="element-85" data-mp="2z82huyss43c5" />
  }
};